import useSWR, { preload } from 'swr';
import { httpResponseToJSON } from '../helpers/fetchHelpers';
import { getAuthenticatedHeaders, simpleFetcher } from './fetchHeaders';
import { logFailedRequestTiming, logRequestTiming } from './insightsHelper';
import { useSelector } from 'react-redux';

export const preloadVesselInfo = (serialNumber, userLanguage) => {
    if(!serialNumber) return;
    preload(`/api/v1/vesselInfo/serial/combined?serialNumber=${serialNumber}&lang=${userLanguage}`, simpleFetcher);
};

export const useVesselInfo = (serialNumber) => {
    const userLanguage = useSelector((state) => state.permissions.language);

    const url = `/api/v1/vesselInfo/serial/combined?serialNumber=${serialNumber}&lang=${userLanguage}`;
    const startTime = performance.now(); // Start timing
    const { data, error, isLoading, isValidating, mutate } = useSWR(
        !!serialNumber ? url : null,
        () => getAuthenticatedHeaders().then((headers) => {
            return fetch(url, { headers })
                .then(response => httpResponseToJSON(response, 'Error loading engine info'/*, showError*/))
        }),
        {
            ...swrConfig,
            onSuccess: (_data, _key) => {
                const endTime = performance.now(); // End timing
                logRequestTiming('/api/v1/vesselInfo/serial/combined?serialNumber=${serialNumber}', Math.round(endTime - startTime));
            },
            onError: (_error, key) => {
                const endTime = performance.now(); // End timing
                logFailedRequestTiming(key, Math.round(endTime - startTime));
            }
        });

    return { data, error, isLoading, isValidating, mutate };
};

export const useOpenRecallCounts = (serialNumber) => {
    const userLanguage = useSelector((state) => state.permissions.language);

    const url = `/api/v1/vesselInfo/serial/openRecall/counts?serialNumber=${serialNumber}&lang=${userLanguage}`;
    const startTime = performance.now(); // Start timing
    const { data, error, isLoading, isValidating, mutate } = useSWR(
        !!serialNumber ? url : null,
        () => getAuthenticatedHeaders().then((headers) => {
            return fetch(url, { headers })
                .then(response => httpResponseToJSON(response, 'Error loading engine info'/*, showError*/))
        }),
        {
            ...swrConfig,
            onSuccess: (_data, _key) => {
                const endTime = performance.now(); // End timing
                logRequestTiming('/api/v1/vesselInfo/serial/openRecall/counts?serialNumber=${serialNumber}', Math.round(endTime - startTime));
            },
            onError: (_error, key) => {
                const endTime = performance.now(); // End timing
                logFailedRequestTiming(key, Math.round(endTime - startTime));
            }
        });

    return { data, error, isLoading, isValidating, mutate };
};

const swrConfig = {
    revalidateOnFocus: false,
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        // Never retry on 4XX error.
        if (error.status >= 400 && error.status < 500) return;

        //   // Never retry for a specific key.
        //   if (key === '/api/user') return

        // Only retry up to 1 times.
        if (retryCount > 1) return;

        // Retry after 1 seconds.
        setTimeout(() => { revalidate({ retryCount }); }, 1000)
    }
};